/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/*
 *
 * Action types for Survey.
 *
 */

import { ReduxUtils } from '@spm/core';

const FETCH_SURVEY_QUESTIONS = ReduxUtils.generateFetchActionTypes(
  'ua-library',
  `SURVEY/FETCH_SURVEY_QUESTIONS`
);

const POST_SURVEY_ANSWERS = ReduxUtils.generatePostActionTypes(
  'ua-library',
  `SURVEY/POST_SURVEY_ANSWERS`
);

export { FETCH_SURVEY_QUESTIONS, POST_SURVEY_ANSWERS };
